module.exports = __webpack_public_path__ + "static/img/sunset-logo9.75670fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sunset-logo9.png
// module id = tmkj
// module chunks = 0